<template>
  <el-dialog
    v-model="dialogFormVisible"
    :title="title"
    width="500px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="会员等级" prop="title">
        <el-select v-model="form.levelId" placeholder="请选择会员等级">
          <el-option
            v-for="item in levels"
            :key="item.levelId"
            :label="item.title"
            :value="item.levelId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="图标名称" prop="title">
        <el-input v-model.trim="form.title" />
      </el-form-item>
      <el-form-item label="图标" prop="avatar">
        <el-upload
          :action="uploadURL"
          :before-upload="beforeAvatarUpload"
          class="avatar-uploader"
          :on-success="handleAvatarSuccess"
          :show-file-list="false"
        >
          <img v-if="form.avatar" class="avatar" :src="form.avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model.trim="form.order" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { addLevelIcon, editLevelIcon, getAllLevels } from '@/api/people'
  import { uploadURL } from '@/config/net.config'

  export default {
    name: 'PeopleLevelIconEdit',
    emits: ['fetch-data'],
    data() {
      return {
        uploadURL,
        levels: [],
        form: {
          levelId: '',
          title: '',
          avatar: '',
          order: 0,
        },
        rules: {
          levelId: [
            { required: true, trigger: 'blur', message: '请选择会员等级' },
          ],
          title: [
            { required: true, trigger: 'blur', message: '请填写会员图标名称' },
          ],
          avatar: [
            { required: true, trigger: 'blur', message: '请上传会员图标' },
          ],
          orrder: [],
        },
        title: '',
        dialogFormVisible: false,
      }
    },
    methods: {
      async getLevels() {
        this.levels = await getAllLevels()
      },
      showEdit(row) {
        if (!row) {
          this.title = '添加'
        } else {
          this.title = '编辑'
          this.form = Object.assign(
            {},
            {
              levelIconId: row.levelIconId,
              levelId: row.levelId,
              title: row.basic.title,
              avatar: row.basic.avatar,
              order: row.basic.order,
            }
          )
        }
        this.dialogFormVisible = true
        this.getLevels()
      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      handleAvatarSuccess(res) {
        this.form.avatar = res.data.url
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG && !isPNG) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
        return (isJPG || isPNG) && isLt2M
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            await (this.form.levelIconId
              ? editLevelIcon(this.form)
              : addLevelIcon(this.form))
            this.$baseMessage(
              this.form.levelIconId ? '修改会员图标成功' : '新增会员图标成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>

<style style="scss" scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
